import PinchZoomComp from './PinchZoom/component';
export default PinchZoomComp;
export { hasTranslate3DSupport, make2dTransformValue, make3dTransformValue, isTouch, } from './utils';
